import { AnimatePresence, motion, useReducedMotion } from 'motion/react'
import { useState } from 'react'
import { products } from '../content/site'
import { ProductIllustration } from './ProductIllustration'
import { SectionLabel } from './SectionLabel'

export function ProductShowcase() {
  const reduceMotion = useReducedMotion()
  const [active, setActive] = useState(0)
  const product = products[active]

  return (
    <section className="section products-section" id="products">
      <div className="shell products-layout">
        <div className="products-heading-row">
          <SectionLabel number="03" label="Products" />
          <div className="products-heading-copy">
            <p className="section-kicker">Product range</p>
            <h2>A focused range of everyday mobile accessories.</h2>
            <p>
              The assortment is built around products customers frequently need to replace, protect or add to their phones.
            </p>
          </div>
        </div>

        <div className="products-desktop-presentation">
          <div className="product-selector" role="tablist" aria-label="Product categories">
            {products.map((item, index) => (
              <button
                type="button"
                role="tab"
                aria-selected={index === active}
                aria-controls="product-stage"
                id={`product-tab-${item.key}`}
                key={item.key}
                className={index === active ? 'is-active' : ''}
                onMouseEnter={() => setActive(index)}
                onFocus={() => setActive(index)}
                onClick={() => setActive(index)}
              >
                <span>{item.id}</span>
                <strong>{item.name}</strong>
              </button>
            ))}
          </div>

          <div className="product-stage media-cut" id="product-stage" role="tabpanel" aria-labelledby={`product-tab-${product.key}`}>
            <AnimatePresence mode="wait">
              <motion.div
                className="product-stage-inner"
                key={product.key}
                initial={reduceMotion ? false : { opacity: 0, clipPath: 'inset(8% 0 8% 0)' }}
                animate={{ opacity: 1, clipPath: 'inset(0% 0 0% 0)' }}
                exit={reduceMotion ? { opacity: 0 } : { opacity: 0, clipPath: 'inset(0 0 92% 0)' }}
                transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
              >
                <div className="product-stage-number" aria-hidden="true">{product.id}</div>
                <motion.div
                  className="product-art"
                  initial={reduceMotion ? false : { opacity: 0, scale: 0.9, rotate: -1.25 }}
                  animate={{ opacity: 1, scale: 1, rotate: 0 }}
                  transition={{ duration: 0.62, delay: reduceMotion ? 0 : 0.05, ease: [0.16, 1, 0.3, 1] }}
                >
                  <ProductIllustration type={product.key} />
                </motion.div>
                <div className="product-caption">
                  <div>
                    <span className="product-caption-index">{product.id}</span>
                    <h3>{product.name}</h3>
                  </div>
                  <div className="product-caption-copy">
                    <p>{product.statement}</p>
                    <small>{product.detail}</small>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
            {!reduceMotion && (
              <motion.div
                className="product-sweep"
                key={`sweep-${product.key}`}
                aria-hidden="true"
                initial={{ scaleY: 0, transformOrigin: 'top' }}
                animate={{ scaleY: [0, 1, 0] }}
                transition={{ duration: 0.58, ease: [0.76, 0, 0.24, 1] }}
              />
            )}
            <div className="media-stamp media-stamp--dark" aria-hidden="true">
              <span>B/</span>
              <span>Accessory range</span>
            </div>
          </div>
        </div>

        <div className="products-mobile-list">
          {products.map((item) => (
            <article className="product-mobile-row" key={item.key}>
              <div className="product-mobile-art media-cut"><ProductIllustration type={item.key} /></div>
              <div className="product-mobile-copy">
                <span>{item.id}</span>
                <h3>{item.name}</h3>
                <p>{item.statement}</p>
                <small>{item.detail}</small>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  )
}
